// @flow

import React from "react";
import { Field } from "redux-form";
import { FormattedMessage, injectIntl } from "react-intl";
import { getClassName } from "ui-kit/utils/component";
import { Input, Button } from "ui-kit/components";

import "./Form.scss";

const ccn = getClassName("WithdrawCurrencyForm");

const WithdrawCurrencyForm = ({ invest, onInputChange, invalid, setValue, clearServerError, intl: { formatMessage } }) => (
  <div className={ccn()}>
    <div className={ccn("form-group")}>
      <Field
        component={Input}
        name="withdraw"
        type="text"
        min={0}
        max={100}
        onChange={onInputChange}
        placeholder="0"
        unit="percentage"
        paddingTop={true}
        clearServerError={clearServerError}
        val={setValue}
      />
    </div>
    <div className={ccn("btnWrap")}>
      <Button onClick={invest} round={true} primary={true} className="Button--withdraw-submit" disabled={invalid}>
        <FormattedMessage id="hbc.withdraw.title" defaultMessage="withdraw" />
      </Button>
    </div>
  </div>
);

export default injectIntl(WithdrawCurrencyForm);



// WEBPACK FOOTER //
// ./src/containers/withdraw/form/Form.js